import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { FaPen, FaRegThumbsUp, FaRegThumbsDown, FaThumbsUp, FaThumbsDown } from 'react-icons/fa6';
import DateTimeFormats from '../../config/date-time-format';
import { GetText, ReplaceText } from '../../config/helper';
import '../../css/blockquotes.css';
import PromptForm from './Form';

const authKey = global.config.kindcode.training[23]+global.config.authBearerKey;

export default class PromptDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      action: '',
      activePage: '',
      typePage: '',
      member_id: localStorage.getItem('doc_id'),
      member_email: "",
      prompt_id: "",
      prompt_category: "",
      prompt_status: "",
      prompt_type: "",
      prompt_data: {},
      likestatususer: "",
      likestatus: "",
      likestatusid: "",
      like: 0,
      dislike: 0,
      modal_show_prompt: false
    }
    this.urllikes = this.urllikes.bind(this);
  }

  handlePopOpen(name) {
    this.setState({ 
      [name]: true,
    });
  }
  handlePopClose(name) {
    this.setState({ 
      [name]: false,
    });
  }
  urllikes(id,nextstat,currstat,subid,user) {
    var currlike=Number(this.state.like); 
    var currdislike=Number(this.state.dislike);

    var datatext;
    var urlFetch = global.config.urlLink;
    if(currstat === "") {
      if(nextstat === global.config.likeStatus[0]) { currlike++; }
      else {  currdislike++; }
      datatext ='{"like_status":"'+nextstat+'","prompt_docid":"'+id+'","form_id":"form-like"}';
      urlFetch = urlFetch+"/promptadd";
      subid = "";
    } else { 
      if(currstat === nextstat) {
        if(nextstat === global.config.likeStatus[0]) { currlike--; }
        else {  currdislike--; }
        nextstat = "";
        datatext ='{"like_status":"'+nextstat+'","docid":"'+id+'","subdocid":"'+subid+'","form_id":"delete-prompt-like"}';
        urlFetch = urlFetch+"/promptdelete";
        subid = "";
      } else {
        if(user === this.state.member_id) {
          if(currstat === global.config.likeStatus[0]) { currlike--; currdislike++; }
          else {  currlike++; currdislike--; }
          datatext ='{"like_status":"'+nextstat+'","prompt_id":"'+id+'","promptlike_id":"'+subid+'","form_id":"form-like"}';
          urlFetch = urlFetch+"/promptedit";
  
        } else {
          if(nextstat === global.config.likeStatus[0]) { currlike++; }
          else {  currdislike++; }
          datatext ='{"like_status":"'+nextstat+'","prompt_docid":"'+id+'","form_id":"form-like"}';
          urlFetch = urlFetch+"/promptadd";
          subid = "";
        }
        
      }
    }
    
    var data = JSON.parse(datatext);
    fetch(urlFetch, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(res => {
        if(res.status === 200)
            return res.json() 
    }).then( resJson => {
        if(resJson.status === '200') {
          if(subid === "") { subid = resJson.values; }
          this.setState({
            likestatususer: this.state.member_id,
            likestatus: nextstat,
            likestatusid: subid,
            like: currlike,
            dislike: currdislike,
          });
         
        } else {
            console.log('Something happened wrong');
        }
       
    });
    
  }
  contentLikeIcons(likestat,like,dislike,createid,memberid,docid,subdocid,likestatuser) {
    var contentIcons = [];
    if(memberid === createid) {
      contentIcons.push(<>
        { this.state.typePage === "browse" && <FaPen className="style-action-icons" aria-label="edit"  onClick={this.handlePopOpen.bind(this,"modal_show_prompt")} />  }
        <FaRegThumbsUp className="style-action-icons-nolink" aria-label="like" /> {this.state.like}
        <FaRegThumbsDown className="style-action-icons-nolink" aria-label="dislike"  /> {this.state.dislike}
      </>)
    } else {
      if(likestat !== "" && likestat === global.config.likeStatus[0] && likestatuser === memberid) {
        contentIcons.push(<>
          <FaThumbsUp className="style-action-icons-on"  aria-label="like" onClick={this.urllikes.bind(this, docid,global.config.likeStatus[0],likestat,subdocid,likestatuser)} /> {like}
        </>)
      } else {
        contentIcons.push(<>
          <FaRegThumbsUp className="style-action-icons"  aria-label="like" onClick={this.urllikes.bind(this, docid,global.config.likeStatus[0],likestat,subdocid,likestatuser)} /> {like}
        </>)
      }

      if(likestat !== "" && likestat === global.config.likeStatus[1] && likestatuser === memberid) {
        contentIcons.push(<>
          <FaThumbsDown className="style-action-icons-on"  aria-label="like" onClick={this.urllikes.bind(this, docid,global.config.likeStatus[1],likestat,subdocid,likestatuser)} /> {dislike}
        </>)
      } else {
        contentIcons.push(<>
          <FaRegThumbsDown className="style-action-icons"  aria-label="like" onClick={this.urllikes.bind(this, docid,global.config.likeStatus[1],likestat,subdocid,likestatuser)} /> {dislike}
        </>)
      }
    }
    return contentIcons;
  }

  componentDidMount() {
    var content = this.props.value;
    var data = {}; 
    if(content.data !== undefined) { data = content.data; }
    var promoType = global.config.specialCategory.filter(ty => ty.link.trim() === content.currpage.trim());
    var promoTypeResult = promoType.length > 0? promoType[0].value : '';
    var promptMyLike={id:"",status:"",createdby:""};
    var numLike=0, numDislike=0;
    if(data.likeData !== undefined) {
      var promptLikeMyStatus = data.likeData.filter(dataItem => dataItem.subcontent.createById === this.state.member_id);
      if(promptLikeMyStatus.length > 0) {
        promptMyLike = {
          "id": promptLikeMyStatus[0].subdocid,
          "status": promptLikeMyStatus[0].subcontent.likeStatus,
          "createdby":  promptLikeMyStatus[0].subcontent.createById
        }
      }
      
      data.likeData.map((promptItemLike, k) => {
        if(promptItemLike.subcontent.likeStatus === global.config.likeStatus[0]) { numLike++; }
        else if(promptItemLike.subcontent.likeStatus === global.config.likeStatus[1]) { numDislike++; }
      
      })
    } else {
      promptMyLike = {
        "id": data.likeStatusId !== undefined? data.likeStatusId : "",
        "status": data.likeStatus !== undefined? data.likeStatus : "",
        "createdby":  data.likeStatusUser !== undefined? data.likeStatusUser : ""
      }
      if(data.numLike !== undefined) { numLike = data.numLike; }
      if(data.numDislike !== undefined) { numDislike = data.numDislike; }
    }
    this.setState({
      action: data.id !== undefined? 'view' : 'add',
      activePage: content.currpage,
      typePage: content.type,
      prompt_id: data.id !== undefined? data.id : '',
      prompt_category: data.promptCategoryId !== undefined? '{"id":"'+data.promptCategoryId+'","name":"'+data.promptCategoryName.trim()+'"}' : '',
      prompt_status: data.promptStatus !== undefined? data.promptStatus : '',
      prompt_type: data.promptType !== undefined? data.promptType : promoTypeResult,
      prompt_data: data,
      likestatususer: promptMyLike.createdby,
      likestatus: promptMyLike.status,
      likestatusid: promptMyLike.id,
      like: numLike,
      dislike: numDislike
    });
  }

  render() {
    return (
        <div className="container mb-4">
          <div id="prompt-detail">
              <div className="mt-1">
                {this.state.typePage === "browse"? 
                  <p className='fs-5 mb-4 lh-sm'>{this.state.prompt_data.promptSubject ?? ""}</p>
                  : 
                  <h4 className='text-dark mb-4 lh-sm'>{this.state.prompt_data.promptSubject ?? ""}</h4>
                }
              </div>
              
              <div className="mt-4">
                <blockquote className="blockstyle">
                  <p className="mb-3">{ReplaceText(this.state.prompt_data.promptContent) ?? ""}</p>
                  {/* <footer className="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer> */}
                </blockquote>
                <p className="mb-3">{ReplaceText(this.state.prompt_data.promptDescription) ?? ""}</p>
              </div>
               
              <div className="mt-4">
                <div className="row">
                  <div className="col-md-4">
                    {this.contentLikeIcons(
                        this.state.likestatus,
                        this.state.like,
                        this.state.dislike,
                        this.state.prompt_data.createById,
                        this.state.member_id,
                        this.state.prompt_data.id,
                        this.state.likestatusid,
                        this.state.likestatususer
                      )}
                  </div>
                 
                  <div className="col-8 text-end">
                    <p className='text-muted'>posted by {this.state.prompt_data.createByName} <br/>{this.state.prompt_data.createDate !== undefined? ("on " + DateTimeFormats(this.state.prompt_data.createDate._seconds,"datetime-short-hhmm")): ''}</p>
                    { (this.state.typePage === "browse" && this.state.prompt_data.createById === this.state.member_id) && 
                      <p className='text-muted mt-3'>visibility : {this.state.prompt_data.promptStatus}</p>
                    }
                  </div>

                </div>
              </div>
                   
          </div>
          <div id="loading-area" className="d-none loading"></div> 

          <Modal animation={false} show={this.state.modal_show_prompt} size="lg" onHide={this.handlePopClose.bind(this,"modal_show_prompt")}>
            <Modal.Header closeButton>
              <Modal.Title>{GetText() ? "Edit data prompt Anda" : "Edit your prompt"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <PromptForm value={{"currpage": this.state.activePage, "data": this.state.prompt_data}} />
            </Modal.Body>
          </Modal>

        </div>
    );
  }
}
